import { render, staticRenderFns } from "./CorrectiveAction.vue?vue&type=template&id=f047e882&scoped=true&"
import script from "./CorrectiveAction.vue?vue&type=script&lang=js&"
export * from "./CorrectiveAction.vue?vue&type=script&lang=js&"
import style0 from "./CorrectiveAction.vue?vue&type=style&index=0&id=f047e882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f047e882",
  null
  
)

export default component.exports